document.addEventListener("DOMContentLoaded", (event) => {
	jQuery(document).on("gform_confirmation_loaded", function (event, formId) {
		if (formId == 2) {
			const dowloadBtn = document.querySelector(".auto-open");
			if (dowloadBtn) dowloadBtn.click();
		}
	});
});
